import app from 'flarum/forum/app';
import TwoFactorEnableModal from './components/TwoFactorEnableModal';
export default function checkForTwoFactor() {
  return new Promise(() => {
    setTimeout(() => {
      var _app$session$user;
      if ((_app$session$user = app.session.user) != null && _app$session$user.mustEnable2FA()) {
        app.modal.show(TwoFactorEnableModal, {
          user: app.session.user,
          forced: true
        });
      }
    }, 300);
  });
}